module.exports = __webpack_public_path__ + "img/login_logo.7d937862.png";